document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.continuous-product-swiper');
  if (!swiperEl) return;

  const perPage = parseInt(swiperEl.dataset.perpage || 4);
  const perPageMobile = parseInt(swiperEl.dataset.perpagemobile || 3);
  const speed = parseInt(swiperEl.dataset.speed || 8000);

  const swiper = new Swiper(swiperEl, {
    slidesPerView: perPage,
    spaceBetween: 5,
    loop: true,
    speed: speed,
    autoplay: {
      delay: 1, // very small delay for smooth continuous scroll
      disableOnInteraction: false,
    },
    grabCursor: true,
    watchSlidesProgress: true,
    breakpoints: {
      1024: { slidesPerView: perPage },
      768: { slidesPerView: perPageMobile },
      480: { slidesPerView: perPageMobile },
      0: { slidesPerView: perPageMobile }
    }
  });

  // Hover events to stop/start autoplay immediately
  swiperEl.addEventListener('mouseenter', () => {
    swiper.autoplay.stop();
  });

  swiperEl.addEventListener('mouseleave', () => {
    swiper.autoplay.start();
  });

  // Optional: force immediate update when tab becomes visible
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      swiper.autoplay.start();
    }
  });
});
